/*jshint esversion: 6 */

import GenericSearch from '../forms/search/GenericSearch.js';
import CategorySearch from '../forms/search/CategorySearch.js';
import FilterSearch from '../forms/search/FilterSearch.js';
import WidgetBespokeNewsPage from "../widgets/WidgetBespokeNewsPage";

GenericSearch();
FilterSearch();
CategorySearch({
    locale: LOCALE,
    env: ENV,
});

window.bespokeNewsPage = new WidgetBespokeNewsPage();

